export interface IReportParameterValue {
    name: string;
    value: string;
}

export class ReportParameterValue implements IReportParameterValue {
    name: string;
    value: string;

    constructor();
    constructor(obj: IReportParameterValue);
    constructor(obj?: any) {
        this.name = obj && obj.name || "";
        this.value = obj && obj.value || "";
    }

    static createReportParameterValue(name: string, value: string): ReportParameterValue {
        const result = new ReportParameterValue();
        result.name = name;
        result.value = value;
        return result;
    }
}